import React from 'react';
import { IOrganisationDetails } from '../../../interfaces';
import { useApi } from '../../../state/ApiContext';
import { useCache } from '../../../state/CachingContext';
import MessageBox from './MessageBox';

const OrganisationMessageBox = ({ isMy }: { isMy?: boolean }): JSX.Element => {
  const { getRequest } = useApi();
  const { getCache } = useCache();

  const [orgDetails, setOrgDetails] = React.useState<IOrganisationDetails | undefined>(undefined);
  const [isLoading, setIsLoading] = React.useState(false);

  const organisationsapplicationsguid = getCache('organisationsapplicationsguid');

  const bootstrapAsync = async (organisationApplicationGuid: string): Promise<void> => {
    await getRequest<{ data: IOrganisationDetails }>(
      'Organisation/OrganisationDetails',
      [{ name: 'organisationApplicationGuid', value: encodeURIComponent(organisationApplicationGuid) }],
      setIsLoading,
    ).then((result) => {
      if (result.data) {
        setOrgDetails(result.data);
      }
    });
  };

  React.useEffect(() => {
    if (organisationsapplicationsguid) bootstrapAsync(organisationsapplicationsguid);
  }, []);

  return (
    <MessageBox
      linkBox
      text={isMy ? 'My AtiQx.ID' : orgDetails ? `${orgDetails.applicationName} (${orgDetails.name})` : 'Invalid OAGuid'}
      isLoading={isLoading}
    />
  );
};

export default OrganisationMessageBox;
